import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { Steps } from './sections';
import { Step } from './sections/Steps/types';
import { Routesteps, OnboardingLocationState, Product } from './types';

import { useOnboarding } from '~contexts/OnboardingContext';

import * as Styled from './styled';
import { RoutesStepsWithCredit, RoutesStepsWithoutCredit } from './constants';

function LeftTracking() {
  const location = useLocation();
  const locationState = location.state as OnboardingLocationState;
  const onboarding = useOnboarding();

  const acquiredProduct = useMemo<Product>(() => {
    if (locationState?.product) return locationState.product;

    if (onboarding) return onboarding.acquired;

    return 'account';
  }, [onboarding, locationState]);

  const stepsParsed = useMemo<Array<Step>>(() => {
    const steps =
      acquiredProduct === 'credit'
        ? RoutesStepsWithCredit
        : RoutesStepsWithoutCredit;

    const parsed = parseSteps(steps);
    return findCheckedSteps(parsed);
  }, [location.pathname, acquiredProduct]);

  function parseSteps(steps: Routesteps[]): Step[] {
    const pathname = location.pathname.replace(/\/$/, '');

    return steps.map((step) => ({
      label: step.label,
      status: step.path === pathname ? 'CURRENT' : 'INITIAL',
    }));
  }

  function findCheckedSteps(steps: Step[]): Step[] {
    const existsCurrentStep = steps.some((step) => step.status === 'CURRENT');

    if (!existsCurrentStep) {
      return steps;
    }

    let isCurrentStepFound = false;
    let isLastStep = false;

    return steps.map((step, index, steps) => {
      // check if it is the last index of the map
      if (steps.length - index === 1) isLastStep = true;

      if (step.status === 'CURRENT') {
        isCurrentStepFound = true;
      }

      if (isCurrentStepFound && !(isLastStep && step.status === 'CURRENT')) {
        return step;
      }

      return {
        ...step,
        status: 'CHECKED',
      };
    });
  }

  return (
    <Styled.Container>
      <Styled.Title>Etapas:</Styled.Title>
      <Steps steps={stepsParsed} />
    </Styled.Container>
  );
}

export default LeftTracking;
